// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".headerText___F-NuN{font-size:calc(var(--made-font-size-08) + 2px);font-family:var(--made-font-family-regular)}\n", "",{"version":3,"sources":["webpack://./src/routes/RuleTests/components/RuleTestsHeader/RuleTestsHeader.css"],"names":[],"mappings":"AAAA,oBACE,8CAAA,CACA,2CAAA","sourcesContent":[".headerText {\n  font-size: calc(var(--made-font-size-08) + 2px);\n  font-family: var(--made-font-family-regular);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headerText": "headerText___F-NuN"
};
export default ___CSS_LOADER_EXPORT___;
